import type {Feature} from '../types';
import {Configuration} from '../configuration';

const storageKey = 'ebba.betaFeatures';

export const getBetaFeatures = (): Feature[] =>
  (Object.keys(Configuration.featureToggles) as Feature[]).filter(
    feature => Configuration.featureToggles[feature] === 'beta',
  );

export const getOptedInBetaFeatures = (): Feature[] => {
  let features: Feature[];
  try {
    const parsed: unknown = JSON.parse(
      localStorage.getItem(storageKey) ?? '[]',
    );
    features = Array.isArray(parsed) ? (parsed as Feature[]) : [];
  } catch {
    features = [];
  }
  return features;
};

export const setOptedInBetaFeatures = (features: Feature[]): void => {
  try {
    localStorage.setItem(storageKey, JSON.stringify(features));
  } catch {
    // Storage unavailable (e.g. private mode), opt-in is not persisted
  }
};
